/* Announcement bar — rotating messages.
   Auto-advances, pauses on hover/focus, supports chevron + dot navigation,
   and respects the Shopify theme editor block selection. */

class AnnouncementBarRotating extends HTMLElement {
  constructor() {
    super();
    this.slides = Array.from(this.querySelectorAll('[data-ab-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-ab-dot]'));
    this.index = 0;
    this.interval = parseInt(this.dataset.interval, 10) || 4500;
    this.timer = null;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  connectedCallback() {
    if (this.slides.length <= 1) return;

    const prev = this.querySelector('[data-ab-prev]');
    const next = this.querySelector('[data-ab-next]');
    if (prev) prev.addEventListener('click', () => this.step(-1));
    if (next) next.addEventListener('click', () => this.step(1));

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        this.show(parseInt(dot.dataset.abIndex, 10));
        this.restart();
      });
    });

    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', this.onBlockSelect.bind(this));
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect.bind(this));
    }

    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  step(direction) {
    this.show(this.index + direction);
    this.restart();
  }

  show(target) {
    const count = this.slides.length;
    this.index = ((target % count) + count) % count;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.index);
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.index);
    });
  }

  start() {
    if (this.timer || this.slides.length <= 1 || this.reduceMotion) return;
    this.timer = setInterval(() => this.show(this.index + 1), this.interval);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  restart() {
    this.stop();
    this.start();
  }

  onBlockSelect(event) {
    const slide = event.target.closest('[data-ab-slide]');
    if (!slide || !this.contains(slide)) return;
    this.stop();
    this.show(parseInt(slide.dataset.abIndex, 10));
  }

  onBlockDeselect() {
    this.start();
  }
}

customElements.define('announcement-bar-rotating', AnnouncementBarRotating);
